import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CorrelationIdService {
  private currentCorrelationId = '';
  private technicalErrorCorrelationId = '';

  createCorrelationId(): string {
    const channel = 'Online';
    const accountId = this.getAuthenticatedAccountId() || 'GUEST';

    return `${channel}-${accountId}-${this.generateUuidV4()}`;
  }

  setCurrentCorrelationId(correlationId: string): void {
    this.currentCorrelationId = String(correlationId ?? '').trim();
  }

  getCurrentCorrelationId(): string {
    return this.currentCorrelationId;
  }

  setTechnicalErrorCorrelationId(correlationId: string): void {
    this.technicalErrorCorrelationId = String(correlationId ?? '').trim();
  }

  getTechnicalErrorCorrelationId(): string {
    return this.technicalErrorCorrelationId;
  }

  private getAuthenticatedAccountId(): string {
    try {
      const loginUser = JSON.parse(localStorage.getItem('login_user') || 'null');
      if (!loginUser) {
        return '';
      }

      const primaryAccount = JSON.parse(localStorage.getItem('primaryAccount') || 'null');
      return String(primaryAccount?.Id ?? '').trim();
    } catch {
      return '';
    }
  }

  private generateUuidV4(): string {
    if (typeof globalThis.crypto.randomUUID === 'function') {
      return globalThis.crypto.randomUUID();
    }

    const bytes = new Uint8Array(16);
    globalThis.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
}
